import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";

// Icons
import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";

// Src
import "../../Style/actionstyle.scss";
import Delete from "../Include/Delete";
import { DELETE_LIST_MATERIAL_UNIT } from "../../Schema/ListMaterialUnit";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import ListMaterialUnitForm from "./ListMaterialUnitForm";
import { deleteFileAPI } from "../../api/api";
import { useMutation as mutationDeleteImage } from "react-query";

export default function ListMaterialUnitAction({ editData, setRefetch }) {
  // Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  // Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);
  // ===============  Mutations delete image  =======================
  const mutationDelete = mutationDeleteImage(deleteFileAPI, {
    onSuccess: (data, variables, context) => {
      if (data?.data?.status) {
        console.log("sucess::", data?.data?.message);
      } else {
        console.log("error::", data?.data?.message);
      }
    },
    onError: (error, variables, context) => {
      console.log(error);
    },
  });

  const [deleteListMaterialUnit] = useMutation(DELETE_LIST_MATERIAL_UNIT, {
    onCompleted: ({ deleteListMaterialUnit }) => {
      // console.log("deleteListMaterialUnit",deleteListMaterialUnit)
      setLoading(false);
      if (deleteListMaterialUnit?.status === true) {
        setAlert(true, "success", deleteListMaterialUnit?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteListMaterialUnit?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
      setLoading(false);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteListMaterialUnit({
      variables: {
        id: editData?._id,
      },
    });
    // let splitSrc = editData.split(":")[4];
    // mutationDelete.mutate({
    //   storage: "school_inventory",
    //   folder: "inventory_images",
    //   file: splitSrc.split("/")[0],
    // });
  };
// console.log("editData",editData)
  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <ListMaterialUnitForm
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        materialId={editData?.materialId}
        setRefetch={setRefetch}
        dialogTitle="Update"
      />

      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"Material"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
